import { useState } from "react";
import { api } from "../../context";

export default function Plans({ t }) {
  const [flash, setFlash] = useState("");
  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;
  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };

  const plans = [
    {
      key: "free", name: "Free", icon: "🆓", price: 0, color: SUB,
      features: ["5 posts/day", "Follow free users", "Basic profile", "3 meetup interests/month (verified)"],
      limits: ["No AI matching", "No movie streaming", "Cannot message premium/elite"],
    },
    {
      key: "premium", name: "Premium", icon: "💎", price: 499, color: PRI,
      ribbon: "MOST POPULAR",
      features: ["Unlimited posts", "Premium badge", "Movie streaming", "AI matching", "Meetups", "Follow free + premium", "Priority in feed"],
      limits: ["Cannot message elite users"],
    },
    {
      key: "elite", name: "Elite", icon: "👑", price: 999, color: GOLD,
      ribbon: "BEST VALUE",
      features: ["Everything in Premium", "Elite gold badge", "Message everyone", "Gold highlighted posts", "Featured on Discover", "Top AI priority", "Event discounts", "Admin WhatsApp support", "Pin 1 post/week"],
      limits: [],
    },
  ];

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>💳 Plans & Pricing</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>Manage subscription plans and features</div>

      {/* Plan cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 20, marginBottom: 32 }}>
        {plans.map((p, i) => (
          <div key={i} style={{ background: CARD, border: `2px solid ${p.color}30`, borderRadius: 16, padding: 24, position: "relative" }}>
            {p.ribbon && (
              <div style={{ position: "absolute", top: -1, right: 16, padding: "4px 12px", background: p.color, borderRadius: "0 0 8px 8px", fontSize: 9, fontWeight: 800, color: "#fff", letterSpacing: "0.05em" }}>{p.ribbon}</div>
            )}
            <div style={{ fontSize: 32, marginBottom: 8 }}>{p.icon}</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: p.color, marginBottom: 4 }}>{p.name}</div>
            <div style={{ fontSize: 32, fontWeight: 900, color: TEXT, marginBottom: 4 }}>
              {p.price === 0 ? "Free" : `KES ${p.price}`}
              {p.price > 0 && <span style={{ fontSize: 13, color: SUB, fontWeight: 600 }}>/mo</span>}
            </div>
            {p.price > 0 && <div style={{ fontSize: 12, color: GRN, fontWeight: 700, marginBottom: 16 }}>MRR potential: KES {(p.price * 10).toLocaleString()}+ at 10 users</div>}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Features</div>
              {p.features.map((f, j) => (
                <div key={j} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 0", borderBottom: `1px solid ${BORDER}20` }}>
                  <span style={{ color: GRN, fontSize: 12 }}>✓</span>
                  <span style={{ fontSize: 12, color: TEXT }}>{f}</span>
                </div>
              ))}
            </div>
            {p.limits.length > 0 && (
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Limits</div>
                {p.limits.map((l, j) => (
                  <div key={j} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 0" }}>
                    <span style={{ color: RED, fontSize: 12 }}>✕</span>
                    <span style={{ fontSize: 12, color: SUB }}>{l}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Pricing info */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>💰 Pricing Strategy</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
          {[
            { label: "Premium Price", value: "KES 499/mo", sub: "~$3.85 USD", color: PRI },
            { label: "Elite Price", value: "KES 999/mo", sub: "~$7.70 USD", color: GOLD },
            { label: "Revenue per 100 subs", value: "KES 74,900", sub: "If 50 premium + 50 elite", color: GRN },
          ].map((s, i) => (
            <div key={i} style={{ background: t.input, borderRadius: 12, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 12, color: SUB, marginTop: 4 }}>{s.label}</div>
              <div style={{ fontSize: 11, color: SUB, marginTop: 2 }}>{s.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Payment methods */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>💳 Payment Methods</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
          {[
            { icon: "📱", label: "M-Pesa STK Push", desc: "Safaricom M-Pesa via Daraja API", status: "Active", color: GRN },
            { icon: "🪙", label: "GT Tokens", desc: "Platform tokens for tickets & features", status: "Active", color: GOLD },
            { icon: "💳", label: "Card Payments", desc: "Visa/Mastercard via Stripe", status: "Coming Soon", color: SUB },
          ].map((m, i) => (
            <div key={i} style={{ background: t.input, borderRadius: 12, padding: 16, border: `1px solid ${BORDER}` }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>{m.icon}</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: TEXT, marginBottom: 4 }}>{m.label}</div>
              <div style={{ fontSize: 11, color: SUB, marginBottom: 10 }}>{m.desc}</div>
              <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: `${m.color}20`, color: m.color }}>{m.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}